var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_c('vue-slider',_vm._b({staticClass:"py-4 my-3",on:{"dragging":_vm.rangeDragEnd},model:{value:(_vm.timeRange),callback:function ($$v) {_vm.timeRange=$$v},expression:"timeRange"}},'vue-slider',_vm.sliderParams,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }